module.exports = __webpack_public_path__ + "media/app/images/unlock-icon-4414e45c780b50f1c8b735cb814c12f7.png";